<template lang="html">
  <v-form ref="form" lazy-validation autocomplete="off">
    <v-card>
      <v-card-title>
        <h2 class="headline mb-0">{{ $tc('label.representacao_conjunto', 1) }}</h2>
      </v-card-title>
      <v-container grid-list-xl fluid>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="representacaoConjunto.idGrupoFornecedor"
              :items="listaGruposFornecedor"
              :label="`${$tc('label.grupo_fornecedor', 1)} *`"
              item-value="id"
              item-text="text"
              item-disabled="indPossuiRepresentacaoConjunto"
              clearable
              :disabled="isEdicao"
              @change="grupoFornecedorAlterado()"
              :rules="[rules.required]"
            ></v-autocomplete>
          </v-col>
          <v-col cols="8"><v-row></v-row>
            <v-switch
              color="primary"
              :label="$t('label.ativo')"
              v-model="representacaoConjunto.indAtivo"
              :disabled="!isEdicao">
            </v-switch>
          </v-col>
        </v-row>
        <v-container grid-list-xl fluid>
          <v-row>
            <v-col cols="12" class="pb-0">
              <h3 class="mb-0">{{ $tc('label.grupo_rep_legal', 2) }}</h3>
            </v-col>
            <v-col cols="4" sm="12" md="4" class="pt-0">
              <v-text-field
                class="Form-text__invalid"
                id="novo_grupo_nome"
                name="novo_grupo_nome"
                v-model="novoGrupo.nomeGrupo"
                :label="`${$t('label.nome_grupo')} *`"
                :counter="100"
                maxlength="100"
                :disabled="somenteLeitura"
                :rules="[rules.required, rules.nomeDuplicado]">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="10" md="6" class="pt-0">
              <v-autocomplete
                v-model="novoGrupo.representantesLegais"
                :items="listaRepresentantesLegais"
                :label="`${$tc('label.representante_legal_grupo', 2)} *`"
                item-value="id"
                item-text="nomeSobrenome"
                return-object
                multiple
                clearable
                chips
                deletable-chips
                :disabled="!isGrupoFornecedorSelecionado || somenteLeitura"
                :rules="[rules.requiredLista, rules.grupoDuplicado]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-btn id="btn_incluir_linha"
                v-if="!somenteLeitura"
                @click.native="incluirGrupoRepresentacao()"
                color="primary">
                {{ $t('label.adicionar') }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-data-table
                id="tabela_listaGrupos"
                :key="tableKey"
                :headers="headers"
                :items="listaGruposRepresentacao"
                :options.sync="pagination"
                :server-items-length="totalPage"
                :no-data-text="$t('label.representacao_conjunto_sem_grupos_elegiveis')"
                :footer-props="{
                  itemsPerPageOptions: [10, 25, 50],
                }"
                >
                <template v-slot:item.acoes="{ item, index }">
                  <v-tooltip bottom v-if="!somenteLeitura">
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mx-0" v-on="on" :disabled="!podeExcluirGrupo(item)" @click="abrirModalExcluirGrupo(item, index)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('label.excluir') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!somenteLeitura">
                    <template v-slot:activator="{ on }">
                      <v-btn icon
                        class="mx-0"
                        v-on="on"
                        :disabled="!item.indAtivo && grupoPossuiDadosInconsistentes(item)"
                        @click="abrirModalAtivarInativarGrupo(item, index)">
                        <v-icon>block</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ !grupoPossuiDadosInconsistentes(item)
                      ? $t('label.ativar_inativa') : $t('message.grupo_possui_dados_inconsistentes') }}
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:item.nome_grupo="{ item }">
                  <span :class="{ 'row--disabled': !item.indAtivo }">
                    {{item.nomeGrupo}}
                  </span>
                </template>
                <template v-slot:item.ind_ativo="{ item }">
                  <span :class="{ 'row--disabled': !item.indAtivo }">
                    {{ item.indAtivo ? $t('label.ativo') : $t('label.inativo')}}
                  </span>
                </template>
                <template v-slot:item.ind_suspenso="{ item }">
                  <span :class="{ 'row--disabled': !item.indAtivo }">
                    <v-tooltip bottom v-if="item.indSuspenso">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="orange darken-1"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                          report_problem
                        </v-icon>
                      </template>
                      <span>{{ $t('label.suspenso') }}</span>
                    </v-tooltip>
                  </span>
                </template>
                <template v-slot:item.nome_representantes_legais="{ item }">
                  <span :class="{ 'row--disabled': !item.indAtivo }">
                    {{item.nomeRepresentantesLegais}}
                  </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="openCancelDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn @click.native="openSaveDialog" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      :max-width="'600'"
      @agree="agreeConfirm()">
    </confirm>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  forceHideLoading,
  forceLoading,
} from '@/common/functions/loading';
import Confirm from '@/shared-components/dialog/Confirm';
import RepresentacaoConjunto from './RepresentacaoConjunto';

export default {
  name: 'RepresentacaoConjuntoForm',
  data() {
    return {
      representacaoConjunto: new RepresentacaoConjunto(),
      representacaoConjuntoResource: this.$api.representacaoConjunto(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      usuarioResources: this.$api.usuario(this.$resource),
      listaGruposFornecedor: [],
      listaRepresentantesLegais: [],
      listaGruposRepresentacao: [],
      listaGruposRepresentacaoNovos: [],
      idGrupoFornecedor: null,
      grupoSelecionado: null,
      indexGrupoSelecionado: null,
      novoGrupo: {
        id: null,
        nomeGrupo: null,
        representantesLegais: [],
      },
      dialog: {
        content: '',
      },
      rules: {
        required: (value) => (!!value && !!value.toString().trim()) || this.$t('message.campo_obrigatorio'),
        requiredLista: (value) => (!!value && value.length > 0) || this.$t('message.campo_obrigatorio'),
        nomeDuplicado: (value) => !this.isGrupoMesmoNome(value) || this.$t('message.grupo_representacao_mesmo_nome'),
        grupoDuplicado: (value) => !this.isGrupoMesmosUsuarios(value) || this.$t('message.grupo_representacao_mesmos_usuarios'),
      },
      pagination: {},
      lastPagination: {},
      totalPage: 0,
      headers: [
        {
          text: '', value: 'acoes', sortable: false, width: '2%', align: 'center', class: 'nowrap', cellClass: 'nowrap',
        },
        {
          text: this.$tc('label.nome_grupo', 1), value: 'nome_grupo', width: '15%', sortable: true, class: 'nowrap', cellClass: 'nowrap',
        },
        {
          text: this.$tc('label.status', 1), value: 'ind_ativo', width: '15%', sortable: true, class: 'nowrap', cellClass: 'nowrap',
        },
        {
          text: this.$tc('label.suspenso', 1), value: 'ind_suspenso', width: '15%', sortable: true, class: 'nowrap', cellClass: 'nowrap',
        },
        {
          text: this.$tc('label.representante_legal_grupo', 2), value: 'nome_representantes_legais', width: '53%', sortable: true, class: 'nowrap',
        },
      ],
      agreeConfirm: () => {},
      tableKey: 0,
      grupoFornPossuiFluxoFornEmAberto: false,
      inativouGrupo: false,
      representacaoConjuntoOriginal: new RepresentacaoConjunto(),
      justificativa: null,
    };
  },
  components: {
    Confirm,
  },
  computed: {
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isGrupoFornecedorSelecionado() {
      return this.representacaoConjunto.idGrupoFornecedor && this.representacaoConjunto.idGrupoFornecedor > 0;
    },
    isEdicao() {
      return this.representacaoConjunto.id != null;
    },
    somenteLeitura() {
      return !this.representacaoConjunto.indAtivo;
    },
    alterouFlagIndAtivo() {
      return this.representacaoConjuntoOriginal.indAtivo !== this.representacaoConjunto.indAtivo;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.mesmaPagina(this.pagination, this.lastPagination)
          && !this.mudouOrdenacao(this.pagination, this.lastPagination)) {
          return;
        }
        this.lastPagination = this.pagination;

        if (this.isGrupoFornecedorSelecionado && this.isEdicao) {
          this.buscarGruposRepresentacao();
        }
      },
      deep: true,
    },
  },
  methods: {
    mesmaPagina(p1, p2) {
      return p1.page === p2.page && p1.itemsPerPage === p2.itemsPerPage;
    },
    mudouOrdenacao(p1, p2) {
      return p1.sortBy.length !== p2.sortBy.length
        || p1.sortBy[0] !== p2.sortBy[0] || p1.sortDesc[0] !== p2.sortDesc[0];
    },
    openCancelDialog() {
      if (this.somenteLeitura) {
        this.cancel();
        return;
      }

      this.dialog.title = this.$t('label.atencao');
      this.dialog.content = this.$t('message.deseja_cancelar_edicao');
      this.agreeConfirm = this.cancel;
      this.$refs.confirmDialog.open();
    },
    cancel() {
      this.limparFormulario();
      this.$router.push({ name: 'representacao-conjunto' });
    },
    carregarRepresentacaoConjunto(id) {
      this.representacaoConjuntoResource.obter({ id })
        .then((res) => {
          this.editar(res.body);
          Promise.all([
            this.buscarRepresentantesLegais(),
            this.buscarGruposRepresentacao(),
          ]).then();
        })
        .catch((err) => {
          this.$error(this, err);
          forceHideLoading();
        });
    },
    editar(representacaoConjunto) {
      this.representacaoConjunto = new RepresentacaoConjunto({ ...representacaoConjunto });
      this.representacaoConjuntoOriginal = new RepresentacaoConjunto({ ...representacaoConjunto });
    },
    limparFormulario() {
      this.representacaoConjunto = new RepresentacaoConjunto();
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.isGrupoFornecedorSelecionado || !this.listaGruposRepresentacao.length) {
        this.$toast(this.$t('errors.campos_obrigatorios.nao_informados'));
        return;
      }

      const { idGrupoFornecedor } = this.representacaoConjunto;
      this.dialog.content = this.$t('message.salvar');
      this.agreeConfirm = this.save;

      if (!this.isEdicao || this.alterouFlagIndAtivo) {
        this.representacaoConjuntoResource.validarGrupoFornecedorPossuiFluxoAberto({ idGrupoFornecedor }).then((response) => {
          this.grupoFornPossuiFluxoFornEmAberto = response.data;
          if (this.grupoFornPossuiFluxoFornEmAberto) {
            if (!this.isEdicao || (this.alterouFlagIndAtivo && this.representacaoConjunto.indAtivo)) {
              this.dialog.title = this.$t('label.atencao');
              this.dialog.content = this.$t('message.deseja_salvar_rep_conj_com_fluxo_em_aberto');
            } else if (this.alterouFlagIndAtivo && !this.representacaoConjunto.indAtivo) {
              this.dialog.title = this.$t('label.atencao');
              this.dialog.content = this.$t('message.deseja_inativar_rep_conj_com_fluxo_em_aberto_cadastro');
            }
          }
          this.$refs.confirmDialog.open();
        }, (err) => {
          this.$error(this, err);
        });
      } else {
        this.$refs.confirmDialog.open();
      }
    },
    save() {
      forceLoading();

      const objArmazenamento = {
        ...this.representacaoConjunto,
        gruposRepresentacaoConjunto: [...this.listaGruposRepresentacao],
        indPossuiFluxoEmAberto: this.grupoFornPossuiFluxoFornEmAberto,
      };

      if (this.grupoFornPossuiFluxoFornEmAberto) {
        const dataAtual = new Date();
        const options = {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
        };
        const horaInativacao = dataAtual.toLocaleString('pt-BR', options);

        if (!this.isEdicao || (this.alterouFlagIndAtivo && this.representacaoConjunto.indAtivo)) {
          this.justificativa = this.$t('message.enviado_analise_automaticamente_por_criacao_representacao_conjunto', { horaInativacao });
        } else if (this.alterouFlagIndAtivo && !this.representacaoConjunto.indAtivo) {
          this.justificativa = this.$t('message.enviado_analise_automaticamente_por_inativacao_representacao_conjunto', { horaInativacao });
        } else if (this.inativouGrupo) {
          this.justificativa = this.$t('message.enviado_analise_automaticamente_por_inativacao_grupo_representacao_conjunto', { horaInativacao });
        }
      }

      let salvarOuAtualizar;
      let inclusao = true;
      if (this.isEdicao) {
        inclusao = false;
        salvarOuAtualizar = this.representacaoConjuntoResource.atualizar(objArmazenamento);
      } else {
        salvarOuAtualizar = this.representacaoConjuntoResource.gravar(objArmazenamento);
      }

      this.processarSave(inclusao, salvarOuAtualizar);
    },
    processarSave(inclusao, salvarOuAtualizar) {
      salvarOuAtualizar
        .then(() => {
          if (this.grupoFornPossuiFluxoFornEmAberto
            && (!this.isEdicao || this.alterouFlagIndAtivo || this.inativouGrupo)) {
            const params = {
              idGrupoFornecedor: this.representacaoConjunto.idGrupoFornecedor,
              justificativa: this.justificativa,
            };
            let promise = null;
            if (!this.isEdicao || (this.alterouFlagIndAtivo && this.representacaoConjunto.indAtivo)) {
              promise = this.workflowContratoResource.enviaAnaliseContratoPorCriacaoRepresentacaoConjunto(params, params);
            } else if (this.inativouGrupo || (this.alterouFlagIndAtivo && !this.representacaoConjunto.indAtivo)) {
              promise = this.workflowContratoResource.enviaAnaliseContratoPorInativacaoGrupoRepresentacaoConjunto(params, params);
            }
            promise
              .then(() => {
                forceHideLoading();
                this.$toast(this.$t((inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela')));
                this.$router.push({ name: 'representacao-conjunto' });
                this.limparFormulario();
              })
              .catch((err) => {
                forceHideLoading();
                this.$error(this, err);
              });
          } else {
            forceHideLoading();
            this.$toast(this.$t((inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela')));
            this.$router.push({ name: 'representacao-conjunto' });
            this.limparFormulario();
          }
        })
        .catch((err) => {
          forceHideLoading();
          this.$error(this, err);
        });
    },
    buscarGruposFornecedores() {
      return this.representacaoConjuntoResource.buscarGruposFornecedoresElegiveis().then((resultado) => {
        resultado.data.forEach((el) => {
          let nomGrupoFornecedor = el.id.toString().concat(' - ').concat(el.idExterno);
          if (this.isTenantEpoca) {
            nomGrupoFornecedor = el.idExterno.toString().concat(' - ').concat(el.nomExtensao);
          }
          const item = { id: el.id, text: nomGrupoFornecedor, indPossuiRepresentacaoConjunto: el.indPossuiRepresentacaoConjunto };
          this.listaGruposFornecedor.push(item);
        });
      });
    },
    grupoFornecedorAlterado() {
      if (!this.isEdicao) {
        let idGrupoFornecedor = null;
        if (this.representacaoConjunto.idGrupoFornecedor) {
          idGrupoFornecedor = this.representacaoConjunto.idGrupoFornecedor;
        }
        this.representacaoConjunto = new RepresentacaoConjunto();
        this.representacaoConjunto.idGrupoFornecedor = idGrupoFornecedor;
        this.novoGrupo.nomeGrupo = null;
        this.novoGrupo.representantesLegais = [];
        this.listaRepresentantesLegais = [];
        this.listaGruposRepresentacao = [];
        this.listaGruposRepresentacaoNovos = [];
        if (this.isGrupoFornecedorSelecionado) {
          this.buscarRepresentantesLegais();
        }
      }
    },
    buscarRepresentantesLegais() {
      const { idGrupoFornecedor } = this.representacaoConjunto;
      return this.usuarioResources.buscarUsuariosRepresentantesLegais({ idGrupoFornecedor }, { idGrupoFornecedor })
        .then((resultado) => {
          this.listaRepresentantesLegais = resultado.data;
          this.$refs.form.resetValidation();
        });
    },
    incluirGrupoRepresentacao() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const novoGrupoInserido = {
        ...this.novoGrupo,
        indAtivo: true,
        indSuspenso: false,
        idRepresentacaoConjunto: this.representacaoConjunto.id,
        idsRepresentantesLegais: this.novoGrupo.representantesLegais.map((rep) => rep.id),
        nomeRepresentantesLegais: '',
        possuiFluxoCriado: false,
        possuiUsuarioInativo: false,
        possuiUsuarioAprovadorAutorizado: false,
        possuiUsuarioOutroGrupoFornecedor: false,
      };

      let nomeRepresentantesLegais = '';
      this.novoGrupo.representantesLegais.sort((a, b) => a.nomeSobrenome - b.nomeSobrenome);
      this.novoGrupo.representantesLegais.forEach((rep) => {
        nomeRepresentantesLegais = nomeRepresentantesLegais
          .concat(rep.nomeSobrenome).concat(', ');
      });
      novoGrupoInserido.nomeRepresentantesLegais = nomeRepresentantesLegais.slice(0, -2);

      this.listaGruposRepresentacao.unshift(novoGrupoInserido);
      this.listaGruposRepresentacaoNovos.unshift(novoGrupoInserido);

      this.totalPage = this.listaGruposRepresentacao.length;

      this.atualizaTabela();
      this.resetarGrupo();
    },
    isGrupoMesmosUsuarios(listaUsuarios) {
      let possuiMesmosUsuarios = false;

      if (listaUsuarios.length) {
        this.listaGruposRepresentacao.every((grupo) => {
          if (grupo.idsRepresentantesLegais.length !== listaUsuarios.length) {
            return true;
          }

          if (!grupo.idsRepresentantesLegais || !grupo.idsRepresentantesLegais.length) {
            grupo.idsRepresentantesLegais = grupo.representantesLegais.map((rep) => rep.id);
          }
          grupo.idsRepresentantesLegais.sort();

          const idsListaUsuarios = listaUsuarios.map((u) => u.id);
          idsListaUsuarios.sort();
          if (grupo.idsRepresentantesLegais.toString() === idsListaUsuarios.toString()) {
            possuiMesmosUsuarios = true;
            return false;
          }
          return true;
        });
      }

      return possuiMesmosUsuarios;
    },
    isGrupoMesmoNome(nomeGrupoInserido) {
      if (!nomeGrupoInserido) return false;
      return this.listaGruposRepresentacao.some((grupo) => this.removerEspacos(grupo.nomeGrupo) === this.removerEspacos(nomeGrupoInserido));
    },
    removerEspacos(texto) {
      return texto.replace(/\s+/g, '');
    },
    buscarGruposRepresentacao() {
      forceLoading();
      const params = {
        id: this.representacaoConjunto.id,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
      };

      if (['nome_grupo', 'nome_representantes_legais'].includes(this.pagination.sortBy[0])) {
        params.colunaOrdenacao = 'lower('.concat(this.pagination.sortBy[0]).concat(')');
      } else {
        const [ordenacao] = this.pagination.sortBy;
        params.colunaOrdenacao = ordenacao;
      }

      this.representacaoConjuntoResource.buscarGruposRepresentacao(params).then((response) => {
        this.listaGruposRepresentacao = response.data.resposta;
        if (this.listaGruposRepresentacaoNovos.length) {
          this.listaGruposRepresentacao.unshift(this.listaGruposRepresentacaoNovos);
        }
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.listaGruposRepresentacao.forEach((grupo) => {
          grupo.idsRepresentantesLegais = grupo.idsRepresentantesLegaisArray.split(',');
        });
        forceHideLoading();
      }, (err) => {
        forceHideLoading();
        this.$error(this, err);
      });
    },
    podeExcluirGrupo(item) {
      return !item.possuiFluxoCriado;
    },
    abrirModalExcluirGrupo(item, index) {
      this.grupoSelecionado = item;
      this.indexGrupoSelecionado = index;
      this.dialog.content = this.$t('message.deseja_excluir_registro');
      this.agreeConfirm = this.excluirGrupo;
      this.$refs.confirmDialog.open();
    },
    excluirGrupo() {
      if (!this.isEdicao) {
        this.listaGruposRepresentacao.splice(this.indexGrupoSelecionado, 1);
      } else {
        const idx = (this.pagination.itemsPerPage * (this.pagination.page - 1)) + this.indexGrupoSelecionado;
        this.listaGruposRepresentacao.splice(idx, 1);
      }
      const indexItemNovo = this.listaGruposRepresentacaoNovos.findIndex((grupo) => grupo.nomeGrupo === this.grupoSelecionado.nomeGrupo);
      this.listaGruposRepresentacaoNovos.splice(indexItemNovo, 1);

      this.totalPage = this.listaGruposRepresentacao.length;
      this.atualizaTabela();
    },
    grupoPossuiDadosInconsistentes(item) {
      return item.id && (item.possuiUsuarioInativo
        || item.possuiUsuarioAprovadorAutorizado || item.possuiUsuarioOutroGrupoFornecedor);
    },
    abrirModalAtivarInativarGrupo(item, index) {
      this.indexGrupoSelecionado = index;

      if (item.id && item.indAtivo) {
        const idGrupoRepresentacao = item.id;

        this.representacaoConjuntoResource.validarGrupoRepresentacaoInativadoPossuiFluxoAberto({ idGrupoRepresentacao }).then((response) => {
          this.grupoFornPossuiFluxoFornEmAberto = response.data;
          if (this.grupoFornPossuiFluxoFornEmAberto) {
            this.abrirModalAtivarInativarGrupoComFluxo(item);
          } else {
            this.abrirModalAtivarInativarGrupoSemFluxo();
          }
        }, (err) => {
          this.$error(this, err);
        });
      } else {
        this.abrirModalAtivarInativarGrupoSemFluxo();
      }
    },
    abrirModalAtivarInativarGrupoComFluxo(item) {
      this.dialog.title = this.$t('label.atencao');
      this.dialog.content = this.$t('message.deseja_inativar_grupo_com_fluxo_em_aberto', { nomeGrupo: item.nomeGrupo });
      this.agreeConfirm = this.ativarInativarGrupo;
      this.$refs.confirmDialog.open();
    },
    abrirModalAtivarInativarGrupoSemFluxo() {
      this.dialog.content = this.$t('message.deseja_ativar_inativar_registro');
      this.agreeConfirm = this.ativarInativarGrupo;
      this.$refs.confirmDialog.open();
    },
    ativarInativarGrupo() {
      const grupo = this.listaGruposRepresentacao[this.indexGrupoSelecionado];
      grupo.indAtivo = !grupo.indAtivo;
      if (!grupo.indAtivo) {
        this.inativouGrupo = true;
      }
      this.atualizaTabela();
    },
    resetarGrupo() {
      this.novoGrupo = {
        id: null,
        nome: null,
        representantesLegais: [],
      };
      this.$refs.form.resetValidation();
    },
    atualizaTabela() {
      this.tableKey += 1;
    },
  },
  mounted() {
    forceLoading();
    Promise.all([
      this.buscarGruposFornecedores(),
    ]).then(() => {
      if (this.$route.params.id) {
        const idRepresentacaoConjunto = parseInt(this.$route.params.id, 10);
        Promise.all([
          this.carregarRepresentacaoConjunto(idRepresentacaoConjunto),
        ]).then();
      } else {
        forceHideLoading();
      }
    });
  },
};
</script>

<style lang="css">
</style>
